"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVideo = void 0;
const hooks_1 = require("preact/hooks");
function useVideo() {
    const [playing, setPlaying] = (0, hooks_1.useState)(false);
    const videoRef = (0, hooks_1.useRef)(null);
    const handleEnded = (0, hooks_1.useCallback)(() => {
        setPlaying(false);
        if (videoRef.current) {
            videoRef.current.currentTime = 0;
        }
    }, []);
    const props = {
        onPlaying: () => setPlaying(true),
        onPause: () => setPlaying(false),
        onEnded: () => handleEnded,
    };
    return [playing, videoRef, props];
}
exports.useVideo = useVideo;
